// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3qJRO","checkboxCol":"Table_checkboxCol__8St51","emailCol":"Table_emailCol__26v7Y","actionCol":"Table_actionCol__2cPXV"};